import cohortsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  queryVariants: createAsyncRequestReducer(cohortsActionTypes.FETCH_VARIANTS),
  queryCopyNumbers: createAsyncRequestReducer(
    cohortsActionTypes.FETCH_COPY_NUMBERS,
  ),
  querySummary: createAsyncRequestReducer(
    cohortsActionTypes.FETCH_GENOMIC_TEST_SUMMARY,
  ),
};

export default combineReducers(reducers);
